import { at, drawLine, growFrom } from '../RailsArchitecture/timelineHelpers';
import {
  ActivateCard,
  ACTIVATIONS,
  AgentsRulesCard,
  Connector,
  DecisionCard,
  EDGE,
} from './atoms';
import { useComboTimeline, type BuildComboTimeline } from './useComboTimeline';

const ID = {
  input: 'combo-input',
  connectA: 'combo-connect-a',
  decision: 'combo-decision',
  connectB: 'combo-connect-b',
  activate: 'combo-activate',
};

const buildDesktopTimeline: BuildComboTimeline = ({ tl, lightActivation }) => {
  // 1. Agents + Rules card: outline draws from the left edge and closes on
  //    the right edge, where the connector leaves.
  tl.addLabel('input', 0.5);
  growFrom(tl, ID.input, 'input', {
    entry: EDGE.left,
    to: 50,
    duration: 0.7,
  });

  // 2. Centred connector into the Decision card.
  tl.addLabel('connectA', at('input', 0.7));
  drawLine(tl, ID.connectA, 'connectA', 0.25);

  // 3. Decision card lights up fully from the left edge.
  tl.addLabel('decision', at('connectA', 0.25));
  growFrom(tl, ID.decision, 'decision', {
    entry: EDGE.left,
    to: 50,
    duration: 0.5,
  });

  // 4. Connector out to the activation list.
  tl.addLabel('connectB', at('decision', 0.5));
  drawLine(tl, ID.connectB, 'connectB', 0.25);

  // 5. Activation card outline, then checkmarks light one by one.
  tl.addLabel('activate', at('connectB', 0.25));
  growFrom(tl, ID.activate, 'activate', {
    entry: EDGE.left,
    to: 50,
    duration: 0.5,
  });
  ACTIVATIONS.forEach((_, index) => {
    tl.call(lightActivation, [index], at('activate', 0.5 + index * 0.12));
  });
};

/**
 * Horizontal diagram. Connectors sit on the vertical centre of the three
 * cards (`items-center`) — matching the product screenshot, not Figma's
 * top-aligned line placement.
 */
export function DesktopAnimation() {
  const { container, litCount } = useComboTimeline(buildDesktopTimeline);

  return (
    <div
      ref={container}
      className="mx-auto flex w-full max-w-[1136px] items-center"
    >
      <AgentsRulesCard borderId={ID.input} />
      <Connector
        id={ID.connectA}
        orientation="horizontal"
        className="w-[45px]"
      />
      <DecisionCard borderId={ID.decision} />
      <Connector
        id={ID.connectB}
        orientation="horizontal"
        className="w-[45px]"
      />
      <ActivateCard borderId={ID.activate} litCount={litCount} />
    </div>
  );
}
